import type { Competency, Dimension } from "../types/PersologOnlineTypes";

export function isCompetencyValueInvalid(competency: Competency, valueIndex: number): boolean {
    const val = competency.values[valueIndex];
    if (val == null) return false;
    return val < competency.min || val > competency.max;
}

export function getDimensionSum(dimension: Dimension): number {
    let sum = 0;
    for (const comp of dimension.competencies) {
        for (const val of comp.values) {
            sum += val ?? 0;
        }
    }
    return sum;
}

export function isDimensionSumInvalid(dimension: Dimension): boolean {
    const sum = getDimensionSum(dimension);
    if (dimension.sumConstraint === "EXACT") return sum !== dimension.max;
    if (dimension.sumConstraint === "MAX") return sum > dimension.max;
    return false;
}

export function isDimensionValid(dim: Dimension): boolean {
    const competenciesValid = dim.competencies.every((comp) =>
        comp.values.every((_, idx) => !isCompetencyValueInvalid(comp, idx)),
    );
    return competenciesValid && !isDimensionSumInvalid(dim);
}
